import { z } from 'zod';

export enum ServiceRecordValues {
	FULL = 'full',
	NO = 'no',
	NOT_APPLICABLE = 'not_applicable',
	NOT_PROVIDED = '-',
	PARTIAL = 'partial',
	SKIPPED = 'skipped',
	YES = 'yes',
}

export const ServiceHistorySchema = z.nativeEnum(ServiceRecordValues);

export const ServiceHistoryRecordItem = z.object({
	createdAt: z.string(),
	date: z.string().nullable(),
	dealershipType: z.string().nullable(),
	gap: z.object({
		distance: z.number().nullable(),
		time: z.number().nullable(),
	}),
	id: z.union([z.string(), z.number()]),
	lapse: z.object({
		distance: z.number().nullable(),
		time: z.number().nullable(),
	}),
	mileage: z.number().nullable(),
	serviceCentre: z.string().nullable(),
	serviceCentreId: z.string().nullable(),
	type: z.string().nullable(),
	updatedAt: z.string(),
	userUpdated: z.boolean(),
	vehicleImageId: z.number().nullable(),
});
